import { useDispatch, useSelector } from 'react-redux';
import React, { useState, createRef, useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import {
  SideMenu,
  RichTextSection,
} from 'design-comuni-plone-theme/components/ItaliaTheme/View';
import { SelectInput } from 'design-comuni-plone-theme/components';
import cx from 'classnames';
import { getUOList } from '@redturtle/volto-io-prenoto/actions/booking';
import moment from 'moment';
import { Card, CardBody, Form, FormGroup, Input } from 'design-react-kit';

import {
  PrenotazioneCardIndirizzoOrario,
  PrenotazioneStepperActions,
} from '@redturtle/volto-io-prenoto/components/View/PrenotazioneView';

const messages = defineMessages({
  ufficio_title: {
    id: 'booking_ufficio_title',
    defaultMessage: 'Ufficio',
  },
  ufficio_desc: {
    id: 'booking_ufficio_desc',
    defaultMessage: 'Scegli l’ufficio a cui vuoi richiedere l’appuntamento',
  },
  ufficio_type_of: {
    id: 'booking_ufficio_type_of',
    defaultMessage: 'Tipo di ufficio',
  },
  ufficio_select_label: {
    id: 'booking_ufficio_select_label',
    defaultMessage: 'Scegli una opzione',
  },
  ufficio_legend: {
    id: 'booking_ufficio_legend',
    defaultMessage: 'Seleziona un ufficio',
  },
  folder_opening: {
    id: 'booking_folder_opening',
    defaultMessage: 'Apertura',
  },
});

const PrenotazioneLuogo = ({
  prenotazioneObj,
  setPrenotazioneObj,
  activeStep,
  setActiveStep,
  scrollToTop,
  params,
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  moment.locale(intl.locale);
  const dateStart = moment();

  // SIDEMENU
  const documentBody = createRef();
  const [sideMenuElements, setSideMenuElements] = useState(null);

  useEffect(() => {
    if (documentBody.current) {
      if (__CLIENT__) {
        setSideMenuElements(documentBody.current);
      }
    }
  }, [documentBody]);

  // UO RESULTS
  const listUO = useSelector((state) => state.listUO);
  const UO = listUO?.result?.items || [];

  /* GET UOLIST */
  useEffect(() => {
    dispatch(getUOList(params.uid, params.booking_type));
  }, []);

  /* Init select with single option if there are one item in UO list */
  useEffect(() => {
    if (UO.length === 1) {
      if (UO[0].prenotazioni_folder.length > 0) {
        setPrenotazioneObj({
          ...prenotazioneObj,
          booking_office: {
            value: UO[0].id,
            label: UO[0].title,
            href: UO[0]['@id'],
            contact_info: UO[0].contact_info,
          },
          avilable_booking_folders: UO[0].prenotazioni_folder,
          booking_folder: UO[0].prenotazioni_folder[0],
        });
      }
    }
  }, [UO]);

  // Return options of UO list
  const returnUOOptions = (UOlist) => {
    let UOOptions = [];
    UOlist.forEach((item) => {
      UOOptions.push({
        value: item.id,
        label: item.title,
        href: item['@id'],
        contact_info: item.contact_info,
      });
    });
    return UOOptions;
  };

  const handleChangeUOSelect = (selectedOption) => {
    // filter item selected
    let itemFocus = [];
    itemFocus = UO.filter((el) => el.id === selectedOption.value);
    let prenotazioniFolder = itemFocus[0]?.prenotazioni_folder ?? [];

    // init radio card first item checked
    if (prenotazioniFolder.length > 0) {
      setPrenotazioneObj({
        ...prenotazioneObj,
        booking_office: selectedOption,
        avilable_booking_folders: prenotazioniFolder,
        booking_folder: prenotazioniFolder[0],
        booking_month: {
          value: dateStart.format('YYYY-MM'),
          label: dateStart.format('MMMM'),
        },
        booking_date: null,
        currentPageDates: 1,
      });
    } else {
      // set only select value
      setPrenotazioneObj({
        ...prenotazioneObj,
        booking_office: selectedOption,
      });
    }
  };

  // RADIO CARD SELEZIONATA
  const handleOfficeChange = (e, folder) => {
    /* set booking folder value and get available date slots */
    setPrenotazioneObj({
      ...prenotazioneObj,
      booking_folder: folder,
      booking_month: {
        value: dateStart.format('YYYY-MM'),
        label: dateStart.format('MMMM'),
      },
      booking_date: null,
      currentPageDates: 1,
    });
  };

  return (
    <>
      {/* MENU LATERALE */}
      <aside aria-hidden={true} className="col-12 col-lg-3">
        {__CLIENT__ && (
          <SideMenu data={sideMenuElements} content_uid={'prenotazioneLuogo'} />
        )}
      </aside>

      {/* MAIN SECTION */}
      <section
        id="main-content-section"
        className="prenotazioneLuogo section-form col-12 col-lg-8 offset-lg-1 mt-3"
        ref={documentBody}
      >
        <RichTextSection
          title={intl.formatMessage(messages.ufficio_title)}
          tag_id="prenotazioneLuogo_section"
          show_title={false}
        >
          <Card className="section-form--card mb-0 no-after">
            {/* SELECT SELEZIONA UFFICIO */}
            <h2 className="mb-0" aria-hidden={true}>
              {intl.formatMessage(messages.ufficio_title)}
            </h2>
            <p className="fw-normal">
              {intl.formatMessage(messages.ufficio_desc)}
            </p>
            <label
              htmlFor="office-choice"
              className="visually-hidden"
              aria-hidden={true}
            >
              {intl.formatMessage(messages.ufficio_type_of)}
            </label>
            <SelectInput
              id="office-choice"
              placeholder={intl.formatMessage(messages.ufficio_select_label)}
              aria-label={intl.formatMessage(messages.ufficio_select_label)}
              value={prenotazioneObj.booking_office}
              options={returnUOOptions(UO)}
              onChange={handleChangeUOSelect}
              role="button"
            />

            {/* LISTA CARTELLE_PRENOTAZIONE */}
            <Form>
              <fieldset>
                <legend className="visually-hidden">
                  {intl.formatMessage(messages.ufficio_legend)}
                </legend>

                {prenotazioneObj.avilable_booking_folders.length > 0 &&
                  prenotazioneObj.avilable_booking_folders.map((folder) => (
                    <Card
                      className={cx('mt-3 p-3 radio-card no-after', {
                        'border-focus-primary':
                          folder.uid === prenotazioneObj.booking_folder.uid,
                      })}
                      key={folder.uid}
                    >
                      <FormGroup check className="form-check-group pb-3">
                        <Input
                          name="gruppo1"
                          type="radio"
                          id={'radio_' + folder.uid}
                          value={folder.uid}
                          checked={
                            folder.uid === prenotazioneObj.booking_folder.uid
                          }
                          onChange={(e) => handleOfficeChange(e, folder)}
                        />
                        <label htmlFor={'radio_' + folder.uid}>
                          <h3 className="fw-semibold">{folder.title}</h3>
                        </label>
                      </FormGroup>

                      <CardBody className="p-0 radio-card--info">
                        <PrenotazioneCardIndirizzoOrario
                          folder={folder}
                          address={folder?.address}
                        />
                      </CardBody>
                    </Card>
                  ))}
              </fieldset>
            </Form>
          </Card>
        </RichTextSection>
      </section>

      {/* BUTTONS */}
      <PrenotazioneStepperActions
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        disabled={!prenotazioneObj.booking_folder?.uid}
        scrollToTop={scrollToTop}
      />
    </>
  );
};

export default PrenotazioneLuogo;
